import { MetabaseAIUsage } from "./UsageGraph";
import { ManageAddOnLink } from "@components/account/plan/ManageAddOns/ManageAddOns.components";
import { AddOnCard } from "@addons/components/AddOnCard";
import { IAddOnSlotProps, IMeteredAddOnDescriptor } from "../types";

export function ManageCard({
  addOn,
}: IAddOnSlotProps<IMeteredAddOnDescriptor>) {
  const { subscribed, purchase, canChangeSubscription, isYearly, title } =
    addOn;
  return (
    <AddOnCard
      isYearly={isYearly}
      productType="metabase-ai-managed"
      title={title}
      description="Track token usage for the current billing cycle."
      usage={<MetabaseAIUsage addOn={addOn} />}
      extra={
        canChangeSubscription && (
          <ManageAddOnLink
            hasAddOn={!!subscribed}
            href={`https://${purchase.hosted_instance?.alias_url}/admin/metabot`}
            hrefLabel="Manage in app"
          />
        )
      }
    />
  );
}
